import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../UI/Login.css';
import { useNavigate } from "react-router-dom";
import { GetLogin,checkCurrentMonthPayment } from "../Services/Authservices";
import { GetDoctorInfo, GetFontStyles, GetLogoImage } from '../Services/Template';
import SpinnerModal from "../Spinner/SpinnerModal";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import Logo from "./Logo/Logo";

const Login = () => {
    const [formData, setFormData] = useState({ Email: "", Password: "" });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const onchange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const FormSubmut = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const { token } = await GetLogin(formData);
            sessionStorage.setItem("token", token);

            if (token) {
                const decodedToken = jwtDecode(token);
                const labId = decodedToken.LabID;
                const userId = decodedToken.UserId;
                const User_Role = decodedToken.role;
                const FirstName = decodedToken.FirstName;
                const LastName = decodedToken.LastName;

                sessionStorage.setItem('LabID', labId);
                sessionStorage.setItem('UserID', userId);
                sessionStorage.setItem('User_Role', User_Role);
                sessionStorage.setItem("FirstName", FirstName);
                sessionStorage.setItem("LastName", LastName);

                if (labId) {
                    // Fetch templates & settings in parallel
                    await Promise.all([
                        DoctorInfo(labId),
                        Fontstyle(labId),
                        getLogo(labId)
                    ]);

                    // Check Billing Status
                    const billingCheck = await checkCurrentMonthPayment(labId);
                    if (!billingCheck.hasPaid) {
                        toast.warning(
                            "Warning: Monthly subscription payment for the current month is pending!",
                            { autoClose: 6000 }
                        );
                        sessionStorage.setItem("BillingWarning", "true");
                    } else {
                        sessionStorage.removeItem("BillingWarning");
                    }
                }

                if (User_Role === 'Admin') {
                    navigate('/Home/Dashboard');
                } else {
                    navigate('/Home/PatientRegistration');
                }
            } else {
                toast.error("Email and password are not correct");
            }
        } catch (error) {
            console.error("Login failed:", error);
            toast.error("Login failed. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const DoctorInfo = async (LabID) => {
        try {
            const response = await GetDoctorInfo(LabID);
            if (response != null) {
                localStorage.setItem('DoctorInfo', response);
            }
        } catch (error) {
            toast.error(error?.message || "Failed to load doctor info");
        }
    };

    const Fontstyle = async (LabID) => {
        try {
            const response = await GetFontStyles(LabID);
            if (response != null) {
                localStorage.setItem('FontStyle', JSON.stringify(response?.[0]));
            } else {
                localStorage.setItem('FontStyle', "");
            }
        } catch (error) {
            toast.error(error?.message || "Failed to load font styles");
        }
    };

    const getLogo = async (LabID) => {
        try {
            const response = await GetLogoImage(LabID);
            if (response != null) {
                localStorage.setItem('LogoImage', response?.[0]?.data);
            }
        } catch (error) {
            toast.error(error?.message || "Failed to load logo");
        }
    };

    return (
        <>
            {isLoading && <SpinnerModal isLoading={true} />}
            <div className="login-container d-flex justify-content-center align-items-center vh-100">
                <div className="card login-card shadow-lg p-4">
                    <div className="text-center mb-4">
                        <Logo
                            containerStyle={{ width: '100%', textAlign: 'center' }}
                            svgStyle={{ width: '60px', height: '60px' }}
                        />
                        <h4 className="ventara-heading mt-2">Ventara Cloud</h4>
                    </div>
                    <form onSubmit={FormSubmut}>
                        <div className="mb-3 text-start">
                            <label className='common-Labels' htmlFor="email">Email</label>
                            <input
                                className="form-control common-Input"
                                id='email'
                                name='Email'
                                required
                                onChange={onchange}
                            />
                        </div>
                        <div className="mb-3 text-start">
                            <label className='common-Labels' htmlFor="password">Password</label>
                            <input
                                className="form-control common-Input"
                                type="password"
                                id='password'
                                name='Password'
                                required
                                onChange={onchange}
                            />
                        </div>
                        <div>
                            <button type="submit" className="Submit_Button w-100 common-FontFamily common-FontWeight">Login</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Login;